import { SET_CURRENT_STORE, SET_CURRENT_STORE_ID_AND_ZIPCODE } from './actionTypes';
import getThdStore from '../utils/getThdStoreInfo';
import isStoreEnabled from '../utils/isStoreEnabled';
import { createAction } from '../utils/createAction';

export const setStore = (store) => (dispatch) => {
  if (store) {
    dispatch({
      type: SET_CURRENT_STORE,
      payload: {
        isStoreEnabled: isStoreEnabled(store.storeId),
        storeId: store.storeId,
        zipcode: store.address && store.address.postalCode,
        storeInfo: store,
      },
    });
  } else {
    dispatch({
      type: SET_CURRENT_STORE,
      payload: {
        storeId: getThdStore().storeNumber || 121,
      },
    });
  }
};

export const setHeaderStoreChanged = (newStore) => (
  createAction(
    SET_CURRENT_STORE_ID_AND_ZIPCODE,
    () => (newStore),
  ))();

export const setStoreChanged = (newStore) => (
  createAction(
    SET_CURRENT_STORE,
    () => (newStore),
  ))();
